import { render, staticRenderFns } from "./FormTextAreaRows.vue?vue&type=template&id=60946773&"
import script from "./FormTextAreaRows.vue?vue&type=script&lang=js&"
export * from "./FormTextAreaRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports